export default __webpack_public_path__ + "static/media/add-device-graphic.df6f3f28.png";